import { useEffect } from "react";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import PropTypes from "prop-types";
import moment from "moment";
import { ErrorMessage } from "formik";
import {
  commonInputStyles,
  labelStyles
} from "components/form_new/component-styles";

const DateInputField = ({ label, field, form, ...rest }) => {
  const errorId = `${field.name}-error`;
  const hasError = form.errors[field.name] && form.touched[field.name];

  useEffect(() => {
    form.setFieldTouched(field.name);
  }, []);

  const getValue = () => {
    if (!field.value) return null;
    if (moment.isMoment(field.value)) return field.value;
    const momentValue = moment(field.value);
    return momentValue.isValid() ? momentValue : null;
  };

  return (
    <div style={{ width: "100%", margin: 0 }}>
      <span
        id={errorId}
        className="form-field-error"
        role="alert"
        aria-live="polite"
        style={{ display: hasError ? "block" : "none", color: "red", fontSize: "0.875rem", marginTop: "4px" }}
      >
        <ErrorMessage name={field.name} />
      </span>

      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DesktopDatePicker
          label={label}
          name={field.name}
          value={getValue()}
          onChange={value => {
            if (value && value.isValid && value.isValid()) {
              form.setFieldValue(field.name, value);
            } else {
              form.setFieldValue(field.name, undefined);
            }
          }}
          slotProps={{
            textField: {
              sx: {
                ...commonInputStyles,
                width: "100%"
              },
              InputLabelProps: {
                sx: labelStyles,
                shrink: true
              },
              error: hasError,
              inputProps: {
                'aria-describedby': hasError ? errorId : undefined,
                'aria-invalid': hasError
              }
            },
            field: {
              clearable: true,
              onClear: () => form.setFieldValue(field.name, undefined)
            },
            popper: {
              sx: {
                '& .MuiPickersCalendarHeader-label': {
                  overflow: 'visible',
                },
                '& .MuiDayCalendar-weekDayLabel': {
                  minWidth: '40px',
                  width: 'auto',
                },
                '& .MuiPickersDay-root': {
                  minWidth: '40px',
                  minHeight: '40px',
                  width: 'auto',
                  height: 'auto',
                },
              }
            },
          }}
          {...rest}
        />
      </LocalizationProvider>
    </div>
  );
};

DateInputField.propTypes = {
  label: PropTypes.string.isRequired,
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onBlur: PropTypes.func
  }),
  form: PropTypes.shape({
    setFieldValue: PropTypes.func,
    setFieldTouched: PropTypes.func,
    errors: PropTypes.object,
    touched: PropTypes.object
  }).isRequired
};

export default DateInputField;
